/* eslint-disable */
import React, { Component } from 'react'
import { View, Text, TouchableOpacity, Dimensions, Image, Animated, ImageEditor, ImageStore } from 'react-native'
import { Fonts, Images } from '../Themes'
import {WebView} from 'react-native-webview'

//import RNFetchBlob from 'react-native-fetch-blob'
import { getAvatar, generateKey, isIPhoneX } from '../Lib/utils'

let { width : w, height : h } = Dimensions.get('window')
  , font = Fonts.style.font.regular

export default class BadgeGenerator extends Component {
  constructor(props) {
    super(props)
    this.state = { badge : '' }
  }

  onErrorWebView = e => {
    console.log("on error web view (keys only) e = " + JSON.stringify(Object.keys(e)))
  }
  onMessage = e => {
    console.log("on message badge gen")
    console.log(e.nativeEvent)
    try {
      var obj = JSON.parse(e.nativeEvent.data)
      if( obj.image && obj.err === false ) {
        console.log('got image data url')
        this.setState({ badge : obj.image })
        if( this.delegateFunction )
          this.delegateFunction( obj.image )
      }
    } catch ( error ) {
      console.warn (error)
      this.setState({ badge : '' })
    }
  }

  imageSize = async ( url ) => {
    if( ! url ) return Promise.resolve({ h : 1242, w : 2208 })
    let result = await new Promise( (resolve, reject) => {
      Image.getSize(url, (w,h) => resolve({ w : w, h : h }))
    })
    return result
  }
  resizeImage = async ( url, size, display = { width : 1242, height : 1242 }) => {
    let b64 = await new Promise( (resolve, reject) => {
      ImageEditor.cropImage( url
        , { offset : { x : 0, y : 0 }
          , size : { width : size.w, height : size.h }
          , displaySize : display
          , resizeMode : 'contain'
          }
        // resolve
        , uri => ImageStore.getBase64ForTag(uri, b64 => resolve(b64), console.warn)
        // reject
        , reject
        )
    })
    return b64
  }

  generateBadge = async ( ) => {
    let avatarUrl = getAvatar(this.props.User.UserId)
      , size = await this.imageSize( avatarUrl )
      , avatar = await this.resizeImage( avatarUrl, size )

      , logoUrl = 'https://s3.amazonaws.com/kargoe-docs/join_me/kargoe_black.png'
      , appleUrl = 'http://s3.amazonaws.com/kargoe-docs/join_me/joinme_apple.png'
      , playUrl = 'http://s3.amazonaws.com/kargoe-docs/join_me/joinme_googleicon.png'
      , logo = await this.resizeImage( logoUrl, await this.imageSize(logoUrl), { width : 493, height : 142 } )
      , apple = await this.resizeImage( appleUrl, await this.imageSize(appleUrl), { width : 85, height : 98 } )
      , play = await this.resizeImage( playUrl, await this.imageSize(playUrl), { width : 71, height : 79 } )

    // get b64 apple icon
    // get b64 google play icon
    var doCan = function doCanvas( ) {
      try {
        var SH = document.createElement('html')
          , canvas = document.createElement('canvas')
          , ctx = canvas.getContext('2d')
          , avatarImage = document.createElement('img')
          , avatarUri = `data:image/jpeg;base64,${window.avatar}`
          , logoUri = `data:image/png;base64,${window.logo}`
          , appleUri = `data:image/png;base64,${window.apple}`
          , playUri = `data:image/png;base64,${window.play}`

          , logoImage = document.createElement('img')
          , appleImage = document.createElement('img')
          , playImage = document.createElement('img')

        canvas.width = 1080
        canvas.height = 1080
        SH.appendChild(canvas)

        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, 1080, 1080)
        var gradient = ctx.createLinearGradient(0,0,0,1080)
        gradient.addColorStop(0, '#b77fd550') // purple
        gradient.addColorStop(1, '#b1e8eb50') // blue
        ctx.fillStyle = gradient
        ctx.fillRect(0, 0, 1080, 1080)

        var radius = 35, x = 100, y = 50, w = 900, h = 900
        ctx.save( )
        ctx.beginPath( )
        ctx.moveTo(x+radius, y)
        ctx.lineTo(x+w-radius, y)
        ctx.quadraticCurveTo(x+w, y, x+w, y+radius)
        ctx.lineTo(x+w, y+h-radius)
        ctx.quadraticCurveTo(x+w, y+h, x+w-radius, y+h)
        ctx.lineTo(x+radius, y+h)
        ctx.quadraticCurveTo(x, y+h, x, y+h-radius)
        ctx.lineTo(x, y+radius)
        ctx.quadraticCurveTo(x, y, x+radius, y)
        ctx.closePath( )
        ctx.shadowColor = '#00000050'
        ctx.shadowBlur = 25
        ctx.shadowOffsetY = 15
        ctx.fillStyle = '#FFFFFFCC'
        ctx.fill( )
        ctx.restore( )
        ctx.fillStyle = 'black'
        if(window.firstlast.match(/[^ ]/g)) {
          ctx.font = 'bold 48px avenir'
          ctx.textAlign = 'center'
          ctx.fillText(window.firstlast, 540, 580)
          ctx.font = '36px avenir'
          ctx.textAlign = 'center'
          ctx.fillText('@'+window.username, 540, 620)
        } else {
          ctx.font = '36px avenir'
          ctx.textAlign = 'center'
          ctx.fillStyle = 'black'
          ctx.fillText('@'+window.username, 540, 580)
        }

        ctx.font = 'italic 60px avenir'
        ctx.textAlign = 'center'
        ctx.fillText('join me on', 540, 740)
        var loading = 4
          , countdown = ( ) => {
            loading -= 1
            if(loading === 0)
              paintImages( )
          }
        avatarImage.onload = countdown
        logoImage.onload = countdown
        appleImage.onload = countdown
        playImage.onload = countdown
        avatarImage.src = avatarUri
        logoImage.src = logoUri
        appleImage.src = appleUri
        playImage.src = playUri
        SH.appendChild(avatarImage)
        SH.appendChild(logoImage)
        SH.appendChild(appleImage)
        SH.appendChild(playImage)

        paintImages = ( ) => {
          ctx.save( )
          ctx.beginPath( )
          ctx.arc(540, 330, 200, 0, Math.PI*2, true)
          ctx.closePath( )
          ctx.clip( )
          ctx.drawImage(avatarImage, 340, 130, 400, 400)
          ctx.beginPath( )
          ctx.arc(340, 130, 200, 0, Math.PI*2, true)
          ctx.closePath( )
          ctx.clip( )
          ctx.restore( )

          ctx.drawImage(logoImage, 294, 760, 493, 142)
          ctx.drawImage(appleImage, 435, 980, 65, 75)
          ctx.drawImage(playImage, 560, 990, 55, 61)
          
          //window.nativePostMessage(JSON.stringify({ image : canvas.toDataURL('image/jpeg', 0.85), err : false }))
          if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) window.ReactNativeWebView.postMessage(JSON.stringify({ image : canvas.toDataURL('image/jpeg', 0.85), err : false }))
          else alert('no post message available in react-native-webview (BadgeGenerator.js)')
        }
      } catch ( err ) {
        window.nativePostMessage(JSON.stringify({ err : err }))
      }
    } // do canv

    let cstring = doCan.toString( )

    // orig
    //this.webview.injectJavaScript(`window.logo = '${logo}'; window.apple = '${apple}'; window.play = '${play}'; window.username = '${this.props.User.Username}'; window.firstlast = '${this.props.User.FirstName} ${this.props.User.LastName}'; window.avatar = '${avatar}'; ${doCanvas.toString( )}; doCanvas( );`)
    this.webview.injectJavaScript(`window.logo = '${logo}'; window.apple = '${apple}'; window.play = '${play}'; window.username = '${this.props.User.Username}'; window.firstlast = '${this.props.User.FirstName} ${this.props.User.LastName}'; window.avatar = '${avatar}';`)
    
    this.webview.injectJavaScript(`${cstring}; doCanvas( );`)

  }
  // false-out web view badge for now, 0.60.5 react, about:blank is causing problems
  // this blocks user going to profile wall
  
  render( ) {
    console.log("in badge gen render")
    // small data url ... 0.60.5 react native, about:blank is causing problems so try this
    const aboutBlank = 'https://google.com'
    return (
        <View style={{ width : 1, height : 1, position : 'absolute' /*, display : 'none' */}}>
          {<WebView
            ref={ref=>this.webview=ref}
            source={{ uri : aboutBlank /*'about:blank'*/}}
            style={{ width : 1, height : 1, opacity : 0 }}
            javaScriptEnabled={true}
            startInLoadingState={true}
            mixedContentMode={'always'}
            allowUniversalAccessFromFileURLs={true}
            onMessage={this.onMessage}
            onError={this.onErrorWebView}
            allowsInlineMediaPlayback={true}
          />}
        </View>
    )
  }
}
